import {Component} from '@angular/core';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Platform} from 'ionic-angular';
import {DateHelper} from '../utils/date-helper';
import {UiServiceProvider} from "../providers/ui-service/ui-service";

@Component({
  templateUrl: "app.html"
})
export class MyApp {
  rootPage: any = "StartPage";

  constructor(
    platform: Platform,
    translate: TranslateService,
    ui: UiServiceProvider
  ) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      translate.onLangChange.subscribe((event: LangChangeEvent) => {
        localStorage.setItem('currentLocale', event.lang);
      });

      let locale = localStorage.getItem('currentLocale');
      if (!locale) {
        locale = 'de';
        localStorage.setItem('currentLocale', locale);
      }
      translate.setDefaultLang(locale);
      translate.use(locale);
      DateHelper.SetLocale(locale);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts